import React, { useState, useEffect, useRef } from 'react';
import { Modal, Form, Dropdown, Stack } from 'react-bootstrap';
import { Icon, Button, CountDown } from 'lb-components';
import { Api } from 'lb-store';

import { Flags } from '../../../assets/icons';

import classes from './PhoneVerificationModal.module.scss';
import _ from 'lodash';

const phoneIndexOptions = [
  { label: '+995', offset: '-176px 0' },
  { label: '+90', offset: '-64px -44px' },
  { label: '+7', offset: '-32px -88px' },
  { label: '+994', offset: '-144px -188px' },
  { label: '+374', offset: '-208px -55px' },
  { label: '+380', offset: '-48px -44px' },
  { label: '+7', offset: '-144px -44px' },
  { label: '+375', offset: '-192px -88px' },
];

export const PhoneVerificationModal = ({ onSuccess, onCancel }) => {
  const [phoneIndex, setPhoneIndex] = useState(phoneIndexOptions[0]);
  const [mobile, setMobile] = useState('');
  const [confirm, setConfirm] = useState(false);
  const [error, setError] = useState({});
  const [timer, setTimer] = useState();

  const otpRef = useRef();

  useEffect(() => {
    Api.User.GetMobile().then((res) => {
      if (res.status && res.data?.status === 1) {
        let prefix = res.data?.prefix.trim();
        if (!prefix.includes('+')) prefix = '+'.concat(prefix);
        setMobile(res.data.mobile);
        setPhoneIndex(phoneIndexOptions.find((i) => i.label === prefix));
      }
    });
  }, []);
  useEffect(() => {
    if (confirm) {
      setTimeout(() => {
        if (otpRef.current) {
          //console.log('focus');
          otpRef.current.focus();
        }
      }, 100);
    }
  }, [confirm]);

  const validate = (formData) => {
    const err = {};
    _.map(formData, (value, key) => {
      if (value === '') err[key] = 'გთხოვთ შეამოწმოთ ველი';
    });
    return err;
  };
  const submit = (formData) => {
    Api.User.OTP(formData).then((res) => {
      if (res?.data?.code === 'sms') {
        if (!confirm) setConfirm(true);
        if (!res?.data?.res) setError({ sms: res.data.desc });
        setTimer(res?.data?.left);
      } else if (res.status && res.data.status === 1) {
        onSuccess();
        onCancel();
      } else {
        setError({ general: res.data?.desc });
      }
    });
  };

  return (
    <Modal show centered contentClassName={classes.modal} onHide={onCancel}>
      <Modal.Header
        closeButton
        closeVariant={'white'}
        style={{ fontSize: '1.5rem' }}
      >
        <Modal.Title className={classes.title}>
          მობილური ტელეფონის ვერიფიკაცია
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={classes.body}>
        <Form
          noValidate
          onSubmit={(e) => {
            e.preventDefault();
            const formData = {
              index: phoneIndex.label,
              mobile: mobile,
            };
            if (confirm) formData.sms = e.target.sms.value;

            const updatedError = validate(formData);
            if (!_.isEmpty(updatedError)) setError(updatedError);
            else {
              submit(formData);
            }
          }}
          className={classes.form}
          id={'verificationForm'}
        >
          {error?.general && (
            <Form.Group className={classes.formGroup} style={{ margin: 0 }}>
              <Form.Label style={{ color: 'var(--bs-danger)' }}>
                {error.general}
              </Form.Label>
            </Form.Group>
          )}
          <Form.Group className={classes.formGroup}>
            <Form.Label>ტელეფონი</Form.Label>
            <div style={{ display: 'flex' }}>
              <Dropdown className={classes.dropdown}>
                <Dropdown.Toggle variant={'secondary'}>
                  <Icon
                    height={'11px'}
                    width={'16px'}
                    Icon={Flags}
                    classname={classes.flag}
                    style={{
                      backgroundPosition: phoneIndex.offset,
                    }}
                  />
                  {phoneIndex.label}
                </Dropdown.Toggle>
                <Dropdown.Menu className={classes.menu}>
                  {phoneIndexOptions.map((item, index) => (
                    <Dropdown.Item
                      key={index}
                      as={'span'}
                      onClick={() => setPhoneIndex(item)}
                    >
                      <Icon
                        height={'11px'}
                        width={'16px'}
                        Icon={Flags}
                        classname={classes.flag}
                        style={{
                          backgroundPosition: item.offset,
                        }}
                      />
                      {item.label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
              <Form.Control
                name={'mobile'}
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
              />
            </div>
            <Form.Control.Feedback type='invalid' className={classes.feedback}>
              {error?.mobile}
            </Form.Control.Feedback>
          </Form.Group>
          {confirm && (
            <>
              <Form.Group className={classes.formGroup}>
                <Form.Label>
                  მიუთითეთ თქვენს ნომერზე გამოგზავნილი SMS კოდი
                </Form.Label>
                <div style={{ position: 'relative' }}>
                  <Form.Control
                    ref={otpRef}
                    autoComplete={'one-time-code'}
                    name={'sms'}
                    type={'number'}
                    isInvalid={error?.sms}
                    onChange={(e) => {
                      setError({ ...error, sms: undefined });
                    }}
                  />
                  {timer && (
                    <div
                      style={{
                        position: 'absolute',
                        right: error?.sms ? 25 : 2,
                        top: '50%',
                        transform: 'translateY(-50%) scale(0.85)',
                      }}
                    >
                      <CountDown
                        onComplete={() => setTimer(undefined)}
                        Duration={timer}
                        Colors={['#ffca2c']}
                        ColorsTime={[0]}
                        BackgroundColor={'#373940'}
                      />
                    </div>
                  )}
                </div>
                <Form.Control.Feedback
                  type='invalid'
                  className={classes.feedback}
                >
                  {error?.sms}
                </Form.Control.Feedback>
                <div>
                  {!timer && (
                    <Form.Label
                      style={{
                        textDecoration: 'underline',
                        color: 'var(--bs-blue-gray)',
                        fontSize: '1.5rem',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        if (otpRef.current) {
                          otpRef.current.focus();
                        }
                        Api.User.OTP({ index: phoneIndex.label, mobile }).then(
                          (res) => {
                            if (!res?.data?.res)
                              setError({ sms: res.data.desc });
                            setTimer(res?.data?.left);
                          }
                        );
                      }}
                    >
                      თავიდან გაგზავნა
                    </Form.Label>
                  )}
                </div>
              </Form.Group>
            </>
          )}
          <div className={classes.buttonsContainer}>
            <Button
              variant={'success'}
              type={'submit'}
              style={{ marginRight: '2rem' }}
            >
              {confirm ? 'დადასტურება' : 'SMS კოდი'}
            </Button>
            <Button variant={'secondary'} type={'button'} onClick={onCancel}>
              გაუქმება
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
